module.exports = __webpack_public_path__ + "img/23.c8138072.png";